import { render, staticRenderFns } from "./financialManagement.vue?vue&type=template&id=c755f4d2&scoped=true&"
import script from "./financialManagement.vue?vue&type=script&lang=js&"
export * from "./financialManagement.vue?vue&type=script&lang=js&"
import style0 from "./financialManagement.vue?vue&type=style&index=0&id=c755f4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c755f4d2",
  null
  
)

export default component.exports